import { AfterViewChecked, AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { TotalumInstanceI } from 'src/app/interfaces/instance.interface';
import { ApiSdkService } from 'src/app/services/api-sdk.service';
import { environment } from 'src/environments/environment';
import { SoloInputComponent } from './components/solo-input/solo-input.component';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-onboarding-flow',
  templateUrl: './onboarding-flow.page.html',
  styleUrls: ['./onboarding-flow.page.scss'],
})
export class OnboardingFlowPage implements OnInit, AfterViewInit, AfterViewChecked {

  loading: boolean = false;
  currentIndex: number = 0;
  invalidForm: boolean = false;
  bigTotalumLoader = false;
  progressBar = 10;
  progressText = 'Ya casi está...';
  progressFinished = false;
  currentYear = new Date().getFullYear();

  // if the user has registred to Totalum for an specific product
  productInterest: string = '';


  @ViewChild(SoloInputComponent, { static: false }) soloInputComponent!: SoloInputComponent;

  onboardingFlowEs: any = [
    {
      id: 'email',
      index: 0,
      display: 'solo-input',
      title: 'Crear cuenta o iniciar sesión',
      subtitle: 'Introduce tu correo electrónico para enviarte correo de confirmación. No hará falta contraseña.',
      placeholder: 'Haz clic aquí e introduce tu correo',
      values: null,
      validation: {
        required: true,
        email: true
      }
    },
    {
      id: 'codigo-verificacion',
      index: 1,
      display: 'solo-input',
      title: 'Introduce el código de verificación',
      subtitle: 'Te hemos enviado un código de 8 dígitos a tu correo electrónico.',
      placeholder: 'Introduce el código de 8 dígitos',
      values: null,
      validation: {
        required: true,
      }
    },
    {
      id: 'datos-personales',
      index: 2,
      display: 'double-input',
      title: 'Introduce tus datos personales',
      subtitle: 'Introduce tu nombre y teléfono para poder continuar.',
      placeholder: ['Introduce tu nombre', 'Introduce tu teléfono'],
      values: null,
      validation: [{
        required: true,
        email: false
      },
      {
        required: true,
        number: false
      }]
    },
    {
      id: 'nombre-totalum',
      index: 3,
      display: 'solo-input',
      title: 'Introduce el nombre de tu Totalum',
      subtitle: 'Tiene que ser todo en minúsculas sin espacios ni caracteres especiales. Aviso: este nombre no se podrá cambiar.',
      placeholder: 'Ejemplo: mi-proyecto-1234',
      values: null,
      validation: {
        required: true,
        totalumName: true
      }
    },
    {
      index: 4,
      finalStep: true,
      bigTotalumLoader: true
    }
  ]

  onboardingFlowEn: any = [
    
      {
        "id": "email",
        "index": 0,
        "display": "solo-input",
        "title": "Create account or sign in",
        "subtitle": "Enter your email address to receive a confirmation email. No password needed.",
        "placeholder": "Click here and enter your email",
        "values": null,
        "validation": {
          "required": true,
          "email": true
        }
      },
      {
        "id": "codigo-verificacion",
        "index": 1,
        "display": "solo-input",
        "title": "Enter the verification code",
        "subtitle": "We've sent you an 8-digit code to your email address.",
        "placeholder": "Enter the 8-digit code",
        "values": null,
        "validation": {
          "required": true
        }
      },
      {
        "id": "datos-personales",
        "index": 2,
        "display": "double-input",
        "title": "Enter your personal details",
        "subtitle": "Enter your name and phone number to continue.",
        "placeholder": ["Enter your name", "Enter your phone number"],
        "values": null,
        "validation": [
          {
            "required": true,
            "email": false
          },
          {
            "required": true,
            "number": false
          }
        ]
      },
      {
        "id": "nombre-totalum",
        "index": 3,
        "display": "solo-input",
        "title": "Enter your Totalum name",
        "subtitle": "It must be all lowercase without spaces or special characters. Note: this name cannot be changed.",
        "placeholder": "Example: my-project-1234",
        "values": null,
        "validation": {
          "required": true,
          "totalumName": true
        }
      },
      {
        "index": 4,
        "finalStep": true,
        "bigTotalumLoader": true
      }

  ];

  onboardingFlow = this.onboardingFlowEn;


  redirectToAccounts = false;
  private hasChildBeenAvailable = false;

  constructor(
    private apiSdkService: ApiSdkService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    private route: ActivatedRoute,
    private mixpanel: MixpanelService,
    private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.currentIndex = 0;
    this.invalidForm = true;

    const currentLang = this.translate.currentLang;
    console.log('Current language onboardng:', currentLang);
    if (currentLang !== 'es') {
      this.onboardingFlow = this.onboardingFlowEn;
    } else {
      this.onboardingFlow = this.onboardingFlowEs;
    }

    //subscribe to language changes
    this.translate.onLangChange.subscribe((event) => {
      console.log('Language changed to:', event.lang);
      if (event.lang === 'es') {
        this.onboardingFlow = this.onboardingFlowEs;
      } else {
        this.onboardingFlow = this.onboardingFlowEn;
      }
    });

    const token = localStorage.getItem('token');
    if (token) {
      // si ya tiene token que redirija a Totalum o a accounts si tiene mas de una o cerrar sesion
      // todo: hacer modal de que decida donde ir o cerrar sesion
      this.getInstanceIfItHasAndRedirect();
    }

    this.route.queryParams.subscribe(async params => {
      // detectar aqui de on ve amb query params
      const productInterest = params['productInterest'];
      if (productInterest && productInterest.length > 3) {
        this.productInterest = productInterest;
      }
      const redirectToAccountsOnVerify = params['redirectToAccounts'];
      if (redirectToAccountsOnVerify) {
        this.redirectToAccounts = true;
      }
    });
  }

  ngAfterViewInit() {
    this.interactWithChildComponent();
  }

  ngAfterViewChecked() {
    this.interactWithChildComponent();
  }


  onChangeValues(event: any) {
    if (!event) {
      this.invalidForm = true;
      return;
    } else {
      this.invalidForm = false;
    }
    this.onboardingFlow[this.currentIndex].values = event;
  }

  async onSubmitStep() {
    this.loading = true;

    // check validation
    if (this.invalidForm) {
      this.loading = false;
      return;
    }

    await this.onGoToNext();
    this.loading = false;
  }

  private interactWithChildComponent() {
    if (this.soloInputComponent && !this.hasChildBeenAvailable) {
      // Child is available, and this is the first time we've noticed it
      this.hasChildBeenAvailable = true;
      //this.soloInputComponent.setFormError({ tokenInvalid: true });
      // Perform any interaction with the child component here
      // For example, trigger an error on the child's form control
    } else if (!this.soloInputComponent) {
      // Child is not available
      this.hasChildBeenAvailable = false;
    }
  }

  async onGoToNext() {
    if (this.currentIndex === this.onboardingFlow.length || this.onboardingFlow?.[this.currentIndex + 1]?.finalStep) {

      if (this.onboardingFlow?.[this.currentIndex + 1]?.bigTotalumLoader) {
        this.bigTotalumLoader = true;
        this.startFakeProgress();

        this.mixpanel.createTracking({
          type: 'click',
          place: 'Register - Final step'
        });

        this.step_createTotalum();
      }

      return;
    } else {

      // ! email step
      if (this.onboardingFlow[this.currentIndex]?.id === 'email') {

        this.mixpanel.createTracking({
          type: 'click',
          place: 'Register - Email step'
        });

        const email = this.onboardingFlow[this.currentIndex].values;
        const result = await this.step_email(email);
        if (!result) {
          return;
        }
      }

      if (this.onboardingFlow[this.currentIndex]?.id === 'codigo-verificacion') {


        this.mixpanel.createTracking({
          type: 'click',
          place: 'Register - Verify code step'
        });

        const code = this.onboardingFlow[this.currentIndex].values;
        const correct = await this.step_verifyCode(code);
        if (!correct) {

          return;
        }
      }

      if (this.onboardingFlow[this.currentIndex]?.id === 'datos-personales') {


        this.mixpanel.createTracking({
          type: 'click',
          place: 'Register - Personal data step'
        });

        const data = this.onboardingFlow[this.currentIndex].values;
        await this.step_personalData(data);
      }

      this.currentIndex++;
      this.invalidForm = true;
    }
  }

  async step_email(email: string) {

    const recaptchaToken = await this.recaptchaV3Service.execute('login').toPromise();

    const result = await this.apiSdkService.sendLoginUrl(email, recaptchaToken as string);
    const errors = result?.error?.errors;
    if (errors) {
      if (errors.includes('fraud')) {
        if (this.soloInputComponent) {
          this.soloInputComponent.setFormError({ emailFraud: true });
        }
      } else {
        if (this.soloInputComponent) {
          this.soloInputComponent.setFormError({ errorDelivery: true });
        }
      }
      return false;
    }
    return true


  }

  async step_verifyCode(code: string) {
    const email = this.onboardingFlow.find((step: any) => step.id === 'email')?.values;
    let registerReason = 'totalum';
    if (this.productInterest && this.productInterest.includes('pdf')) {
      registerReason = 'docreatum';
    } else if (this.productInterest && this.productInterest.includes('scan')) {
      registerReason = 'scanum';
    }
    let options = {
      registerReason: registerReason
    };
    const result = await this.apiSdkService.login(email, code, options);


    if (result.success?.data) {
      localStorage.setItem('token', result.success.data);

      if (this.redirectToAccounts) {
        this.router.navigate(['/user-data']);
        return true;
      }

      //afeguir aqui

      // si ya tiene instancias que redirija a Totalum o a accounts si tiene mas de una
      await this.getInstanceIfItHasAndRedirect();
      return true;
    } else {

      if (result?.error?.errors === 'Error: Too many loginTries') {
        if (this.soloInputComponent) {
          this.soloInputComponent.setFormError({ tooManyIntents: true });
        }
      } else {
        if (this.soloInputComponent) {
          this.soloInputComponent.setFormError({ tokenInvalid: true });
        }
      }


      return false;
    }
  }

  async getInstanceIfItHasAndRedirect() {
    const fullUserData = await this.apiSdkService.getFullUserData();
    const userData = fullUserData?.success?.data;


    if (userData?.totalumInstances.length === 0) {
      // continua en el flow
    }

    if (userData?.totalumInstances.length === 1) {
      await this.openTotalumInstance(userData?.totalumInstances[0]);
      return;
    }

    if (userData?.totalumInstances.length > 1) {
      this.router.navigate(['/account']);
      return;
    }

  }

  async step_personalData(data: any) {

    const name = data?.firstValue;
    const phone = data?.secondValue;

    await this.apiSdkService.editUserData({
      name,
      phone,
    });
  }

  async step_createTotalum() {
    // first create the Totalum
    let totalumName = this.onboardingFlow.find((step: any) => step.id === 'nombre-totalum')?.values;
    const recaptchaToken = await this.recaptchaV3Service.execute('createInstance').toPromise();
    const instance: TotalumInstanceI = {
      organizationId: totalumName,
      plan: 'free',
      description: ''
    }

    const result = await this.apiSdkService.createInstance(instance, recaptchaToken as string);

    if (result.error) {

      return;
    }

    // then open the Totalum
    this.openTotalumInstance(result.success.data);
  }

  async openTotalumInstance(instance: TotalumInstanceI) {
    const organizationId = instance.organizationId;
    /*const data = localStorage.getItem(organizationId) as string;
    const decryptedDataString = await this.utilsService.decrypt(data, organizationId);
    //console.log('decryptedDataString',decryptedDataString)
    const result = await this.apiSdkService.crypt(decryptedDataString);
    const cryptedDataString = result.success.data;*/
    const cryptedDataString = instance.defaultUser as string;
    const cryptedDataStringEncoded = encodeURIComponent(cryptedDataString);
    let urlToOpen = `${environment.totalumFrontendUrl}auth/login?auth=${cryptedDataStringEncoded}&organizationId=${organizationId}`;
    if (this.productInterest && this.productInterest.length > 3) {
      urlToOpen += `&productInterest=${this.productInterest}`;
    }
    window.location.href = urlToOpen;
  }

  startFakeProgress() {
    this.progressBar = 10;
    this.progressText = 'Creating your Totalum...';
    setTimeout(() => {
      this.progressBar = 20;
      setTimeout(() => {
        this.progressBar = 50;
        setTimeout(() => {
          this.progressBar = 70;
          this.progressText = 'Almost there...';
          setTimeout(() => {
            this.progressBar = 90;
            setTimeout(() => {
              this.progressBar = 100;
              setTimeout(() => {
                this.progressFinished = true;
                this.progressText = 'Done! We are redirecting you to your Totalum';
              }, 2500);
            }, 2500);
          }, 2500);
        }, 2500);
      }, 2500);
    }, 2500);
  }
}
